export namespace ListOutboundTypes {
    export enum Types {
        Entrepot = "Entrepot",
        T1 = "T-1",
        Vrij = "Vrij",
        AGP = "AGP"
    }
}
